routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
    $stateProvider
        .state('home.address', {
            url: __env.routes.address,
            template: `<address sh-ctrl="shCtrl"></address>`
        });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/address/address.config.js